import * as React from 'react';
import FileImage from '../images/FileImage.component';

interface IdentificationDocumentFileComponentProps {
  idFile?: File;
  noIdFileText: string;
  isIdFileText: string;
  noIdFileImg: string;
  handleChange: (key: string) => (value: string | File | boolean) => void;
}

export class IdentificationDocumentFileComponent extends React.Component<IdentificationDocumentFileComponentProps> {

  public render(): React.ReactNode {
    if (this.props.idFile) {
      return [
        (
          <FileImage
            alt="id_front"
            defaultImagePath={'/img/corrected.png'}
            className="id-file-image-img"
          />
        ), (
          <p className="id-file-image-txt">
            {this.props.isIdFileText}
          </p>
        )
      ];
    } else {
      return [
        (
          <FileImage
            alt="id_front"
            defaultImagePath={this.props.noIdFileImg}
            className="id-file-image-img"
          />
        ), (
          <p className="id-file-image-txt">
            {this.props.noIdFileText}
          </p>
        )
      ];
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/commons/identification-document-file/IdentificationDocumentFileComponent.tsx